import { render, staticRenderFns } from "./add_address.vue?vue&type=template&id=a456ef38&scoped=true"
import script from "./add_address.vue?vue&type=script&lang=js"
export * from "./add_address.vue?vue&type=script&lang=js"
import style0 from "./add_address.vue?vue&type=style&index=0&id=a456ef38&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a456ef38",
  null
  
)

export default component.exports